import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", null, "商品"),
    /*#__PURE__*/_createElementVNode("th", null, "市场价"),
    /*#__PURE__*/_createElementVNode("th", null, "回收价"),
    /*#__PURE__*/_createElementVNode("th", null, "数量"),
    /*#__PURE__*/_createElementVNode("th", null, "采购价"),
    /*#__PURE__*/_createElementVNode("th", null, "已采购")
  ])
], -1)
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.shipping_order,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "用户匿称",
          prop: "user_nickname"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.shipping_order.user_nickname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shipping_order.user_nickname) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "用户手机号码",
          prop: "user_mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.shipping_order.user_mobile,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shipping_order.user_mobile) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "收件人姓名",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.shipping_order.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shipping_order.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "收件人手机号码",
          prop: "mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.shipping_order.mobile,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.shipping_order.mobile) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "收件人地区",
          prop: "area"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.shipping_order.area,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.shipping_order.area) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "收件人详细地址",
          prop: "address_detail"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.shipping_order.address_detail,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.shipping_order.address_detail) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "备注",
          prop: "note"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.shipping_order.note,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.shipping_order.note) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "发货物流",
          prop: "shipping_provider"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.shipping_order.shipping_provider,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.shipping_order.shipping_provider) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "发货单号",
          prop: "shipping_no"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.shipping_order.shipping_no,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.shipping_order.shipping_no) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "状态",
          prop: "status"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.shipping_order.status,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.shipping_order.status) = $event)),
              disabled: _ctx.shipping_order.status !== 'pending'
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([{key: '待发货', value: 'pending'}, {key: '已发货', value: 'deliver'}, {key: '已取消', value: 'cancel'}], (item) => {
                  return _createVNode(_component_el_option, {
                    label: item.key,
                    value: item.value,
                    key: item.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createElementVNode("table", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipping_order.details, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id
              }, [
                _createElementVNode("td", null, _toDisplayString(item.name), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(item.price)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(item.recycle_price)), 1),
                _createElementVNode("td", null, _toDisplayString(item.count), 1),
                _createElementVNode("td", null, [
                  (item.purchased)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        "onUpdate:modelValue": ($event: any) => ((item.purchase_price) = $event)
                      }, null, 8, _hoisted_4)), [
                        [_vModelText, item.purchase_price]
                      ])
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.formatPrice(item.purchase_price)), 1))
                ]),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((item.purchased) = $event)
                  }, null, 8, _hoisted_6), [
                    [_vModelCheckbox, item.purchased]
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}